import React from "react";
import 'animate.css';
import './zodiacImage.scss'
import "../../chat/animate/slide_in_left.css";
import { ImagePreview } from 'react-vant';
import imageSrc from '../../../assets/update_new/new_199_free.png';
const ZodiacImage = ({ avator, content, getReport }) => {
    const report = () => {
        getReport(JSON.parse(content).md5_hash)
    }
    return (
        <div className="ai_content_astrolabe slide-in-left" >
            <img className="ai_avatar" src={avator} />
            <div className="ai_content_message">
                <img className="star_disk"
                    onClick={() => ImagePreview.open({ images: [JSON.parse(content).pic_url], startPosition: 0 })}
                    src={JSON.parse(content).pic_url} />
                <img className="free_199" onClick={report} src={imageSrc}></img>
            </div>
        </div>
    )
}
export default ZodiacImage;